// eslint-disable-next-line import/no-cycle
import { period as schemaPeriod } from './schemas';
import apiClient from './apiClient';
import PeriodDataStore from '../../datastores/PeriodDataStore';

class PeriodDataStoreGraphQL implements PeriodDataStore {
  async getCurrentPeriod(periodParam: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPeriod.getCurrentPeriod,
        variables: { period: periodParam },
        fetchPolicy: periodParam ? 'cache-first' : 'no-cache'
      });
      const { period } = response.data;
      return period;
    } catch (error) {
      throw new Error('error period');
    }
  }
}

export default PeriodDataStoreGraphQL;
